import React, { useEffect } from 'react';
import { HashRouter as Router, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';
import { LoginProvider } from './context/loginContext';
import Login from './pages/login/login';
import ProtectedRoute from './pages/protectedRoute/protectedRoute';
import HomeAdministrador from './pages/administrador/home/homeAdministrador';
import Clientes from './pages/administrador/clientes/clientes';
import Productos from './pages/administrador/productos/productos';
import Conceptos from './pages/administrador/conceptos/conceptos';
import Exportacion from './pages/administrador/exportacion/exportacion';
import Importacion from './pages/administrador/importacion/importacion';
import Usuarios from './pages/administrador/usuarios/usuarios';
import MainLayout from './pages/layout/mainLayout';
import { ADMIN_ROLES, PANEL_ROLES } from './constants/roles';

const RootRoute = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/login', { replace: true });
  }, [navigate]);
  return null;
};

function App() {
  return (
    <ConfigProvider
      componentSize="small"
      theme={{
        algorithm: [theme.defaultAlgorithm, theme.compactAlgorithm],
        token: {
          colorPrimary: '#198039',
          colorBgBase: '#f3faf6',
          colorBgLayout: '#f3faf6',
          colorBgContainer: '#ffffff',
          colorText: '#1f2937',
          colorBorder: '#d8e8dc',
          colorLink: '#198039',
        },
        components: {
          Menu: {
            itemSelectedColor: '#198039',
            itemSelectedBg: 'rgba(25, 128, 57, 0.12)',
            itemHoverBg: 'rgba(25, 128, 57, 0.06)',
            itemActiveBg: 'rgba(25, 128, 57, 0.1)',
          },
          Layout: {
            headerBg: '#ffffff',
            bodyBg: '#f3faf6',
            siderBg: '#ffffff',
          },
        },
      }}
    >
      <LoginProvider>
        <Router>
          <Routes>
            <Route path="/" element={<RootRoute />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/administrador/home"
              element={
                <ProtectedRoute allowedRoles={PANEL_ROLES}>
                  <MainLayout>
                    <HomeAdministrador />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/administrador/clientes"
              element={
                <ProtectedRoute allowedRoles={PANEL_ROLES}>
                  <MainLayout>
                    <Clientes />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/administrador/productos"
              element={
                <ProtectedRoute allowedRoles={PANEL_ROLES}>
                  <MainLayout>
                    <Productos />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/administrador/conceptos"
              element={
                <ProtectedRoute allowedRoles={PANEL_ROLES}>
                  <MainLayout>
                    <Conceptos />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/administrador/exportacion"
              element={
                <ProtectedRoute allowedRoles={PANEL_ROLES}>
                  <MainLayout>
                    <Exportacion />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/administrador/importacion"
              element={
                <ProtectedRoute allowedRoles={PANEL_ROLES}>
                  <MainLayout>
                    <Importacion />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/administrador/usuarios"
              element={
                <ProtectedRoute allowedRoles={ADMIN_ROLES}>
                  <MainLayout>
                    <Usuarios />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </LoginProvider>
    </ConfigProvider>
  );
}

export default App;
